export const DEFAULT_SUPPORT_EMAIL = 'service@imgbed.cn';
export const CONTACT_EMAIL_BOOTSTRAP_ELEMENT_ID = 'img-cloud-contact-email-data';
export const CONTACT_EMAIL_ENDPOINT = '/config/contact-email';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

interface ContactEmailData {
  supportEmail: string;
}

let cachedSupportEmail: string | undefined;
let inflightRequest: Promise<string> | undefined;

const isValidEmail = (value: unknown): value is string =>
  typeof value === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const readSupportEmailBootstrapData = (): string => {
  const element = document.getElementById(CONTACT_EMAIL_BOOTSTRAP_ELEMENT_ID);
  if (!element?.textContent) return DEFAULT_SUPPORT_EMAIL;
  try {
    const value = JSON.parse(element.textContent) as Partial<ContactEmailData>;
    return isValidEmail(value.supportEmail) ? value.supportEmail : DEFAULT_SUPPORT_EMAIL;
  } catch (error) {
    console.warn('Failed to parse contact email build data', error);
    return DEFAULT_SUPPORT_EMAIL;
  }
};

export const fetchSupportEmail = (): Promise<string> => {
  if (cachedSupportEmail) return Promise.resolve(cachedSupportEmail);
  if (inflightRequest) return inflightRequest;

  inflightRequest = fetch(CONTACT_EMAIL_ENDPOINT, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'same-origin',
  })
    .then(async (response) => {
      const result = (await response.json()) as ApiResponse<Partial<ContactEmailData>>;
      const supportEmail = result.data?.supportEmail;
      if (!response.ok || !result.success || !isValidEmail(supportEmail)) {
        throw new Error(result.message || '联系邮箱加载失败');
      }
      cachedSupportEmail = supportEmail;
      return cachedSupportEmail;
    })
    .finally(() => {
      inflightRequest = undefined;
    });
  return inflightRequest;
};

export const resetSupportEmailCacheForTest = () => {
  cachedSupportEmail = undefined;
  inflightRequest = undefined;
};
